import {LobbyImage} from '@colonist/types'
import {ModeSettingEnum} from '../../../../../shared/GameEnums'
import {GameSettings} from '@colonist/game-base-types'
import {RulebookPage} from '../../../../../shared/enums/RulebookEnums'
import {CA} from '../../analytics/Analytics'
import {showRulebookPopup} from '../../ui_rulebook/UIRulebookPopupGlobal'
import {UIGameHelpButtonsController} from './UIGameHelpButtonsController'
import {uiGameManager} from '../../EntryShared'
import {UIGameHelpButton} from './UIGameHelpButton'

export default class UIGameRulesButton extends UIGameHelpButton {
    private readonly modeSetting: ModeSettingEnum
    constructor(uiGameHelpButtonController: UIGameHelpButtonsController, parent: HTMLDivElement, gameSettings: GameSettings) {
        super(uiGameHelpButtonController, parent, 'rules-button', LobbyImage.Rulebook)
        this.modeSetting = gameSettings.modeSetting
    }

    clicked(event: PointerEvent) {
        super.clicked(event)
        UIGameRulesButton.openRulebook(this.modeSetting)
    }

    static gameModeToRulebookPage(gameMode: ModeSettingEnum): RulebookPage {
        switch(gameMode) {
            case ModeSettingEnum.Classic56P: return RulebookPage.Classic56P
            case ModeSettingEnum.Classic78P: return RulebookPage.Classic56P
            case ModeSettingEnum.Seafarers4P: return RulebookPage.Seafarers4P
            case ModeSettingEnum.Seafarers56P: return RulebookPage.Seafarers4P
            case ModeSettingEnum.CitiesAndKnights4P: return RulebookPage.CitiesAndKnights4P
            case ModeSettingEnum.CitiesAndKnights56P: return RulebookPage.CitiesAndKnights4P
            case ModeSettingEnum.CitiesAndKnightsSeafarers4P: return RulebookPage.CitiesAndKnights4P
            case ModeSettingEnum.CitiesAndKnightsSeafarers56P: return RulebookPage.CitiesAndKnights4P
            default: return RulebookPage.Classic4P
        }
    }

    static openRulebook(modeSetting: ModeSettingEnum) {
        uiGameManager.pauseController.pauseIfSinglePlayer()
        CA.sendGoogleAnalyticsEvent(CA.Category.Game, CA.Label.ClickedGameRulesButton)
        const defaultRulebookPage = UIGameRulesButton.gameModeToRulebookPage(modeSetting)
        showRulebookPopup(defaultRulebookPage)
    }
}
